import { categoryData } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 text-xs font-label font-semibold tracking-wider uppercase rounded-full border border-secondary-300 text-secondary-600">
            Категории
          </span>
          <h2 className="mt-4 text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 max-w-2xl mx-auto leading-tight">
            Выберите категорию
            <br />
            для быстрого перехода
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            Удобная навигация по 14 категориям товаров. Нажмите на любую категорию, чтобы перейти к заказу через YOYbuy Sheet.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categoryData.map((cat) => (
            <a
              key={cat.nameEn}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-start p-5 md:p-6 rounded-xl bg-background-100 border border-background-200 hover:bg-primary-100/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-secondary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl text-secondary-600 group-hover:text-primary-700 transition-colors`}></i>
              </div>
              <h3 className="mt-4 text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-800 transition-colors leading-snug">
                {cat.name}
              </h3>
              <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-secondary-500 group-hover:text-primary-600 transition-colors">
                Перейти
                <i className="ri-arrow-right-up-line text-xs"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}